import { useInView } from "react-intersection-observer";
import styled from "styled-components";
import Image from "../../../assets/images/image/postcard.png";
import { appear } from "../../../components/animations/Appear";
import UnderlineButton from "../../../components/buttons/UnderlineButton";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  max-width: 540px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: ${({ inView }) => (inView ? appear : "none")} 2s forwards;

  @media (max-width: 950px) {
    max-width: 100%;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  aspect-ratio: 1.5 /1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  padding-bottom: 10px;
`;

const Title = styled.h3`
  font-weight: 400;
  font-size: ${fontSize.s};
  letter-spacing: 0.08rem;
  color: ${colors.black};
  margin-bottom: 4px;
  text-transform: uppercase;
`;

const Name = styled.h5`
  line-height: 1.8rem;
  font-weight: 400;
  font-size: ${fontSize.xxs};
  letter-spacing: 0.08rem;
  color: ${colors.primaryGray};
  text-transform: uppercase;
`;

const Description = styled.p`
  letter-spacing: 0.04rem;
  color: ${colors.black};
  font-size: ${fontSize.xs};
  line-height: 1.2rem;

  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

function JournalCard({ journal }) {
  const { ref, inView } = useInView({ triggerOnce: true });
  return (
    <Wrapper ref={ref} inView={inView}>
      <ImageWrapper>
        <img src={journal.image} alt="journal-entry" />
      </ImageWrapper>
      <div>
        <Title>{journal.title}</Title>
        <Name>{journal.author}</Name>
      </div>
      <div>
        <Description>{journal.description}</Description>
        {/* <UnderlineButton placeholder={"Read More"} /> */}
      </div>
    </Wrapper>
  );
}

export default JournalCard;
